import { render, staticRenderFns } from "./DepositWhithoutLogin.vue?vue&type=template&id=bfbaff7c&scoped=true&"
import script from "./DepositWhithoutLogin.vue?vue&type=script&lang=js&"
export * from "./DepositWhithoutLogin.vue?vue&type=script&lang=js&"
import style0 from "./DepositWhithoutLogin.vue?vue&type=style&index=0&id=bfbaff7c&scoped=true&lang=css&"
import style1 from "./DepositWhithoutLogin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbaff7c",
  null
  
)

export default component.exports